export const MAIN = 'Main'
export const CHAT = 'Chat'
export const PREPARE_TO_CALL = 'PrepareToCall'
export const CALL_SESSION = 'CallSession'
export const LOGIN = 'Login'
export const INVITE_LOGIN = 'InviteLogin'
export const CONFERENCE_INTERNAL_LINK_DENIED = 'ConferenceInternalLinkDenied'
export const TOKEN_LOGIN = 'TokenLogin'
export const GUEST_PREPARE_TO_CALL = 'GuestPrepareToCall'
export const GUEST_ROOM_CHAT = 'GuestRoomChat'
export const GUEST_CALL_SESSION = 'GuestCallSession'
export const VIEW_SETTINGS = 'ViewSettings'
export const CALENDAR = 'Calendar'
export const GENERAL = 'General'
export const SOUND_AND_VIDEO = 'SoundAndVideo'
export const CALLS = 'Calls'
export const TERMINALS = 'Terminals'
export const AUTOMATIC_TERMINALS_SETUP = 'AutomaticTerminalsSetup'
export const ACCOUNT = 'Account'
export const CONFIDENTIALITY = 'Confidentiality'
export const NOTIFICATIONS = 'Notifications'
export const ALARM_SCHEDULE = 'AlarmSchedule'
export const ABOUT = 'About'
export const BYE = 'Bye'
export const CONFERENCE = 'conference'
export const SUPPORT = 'Support'
export const INTERFACE_SETTINGS = 'InterfaceSettings'
export const SUPPORT_SETTINGS_GENERAL = 'SupportSettingsGeneral'
export const SUPPORT_SETTINGS_SUBSCRIBER_ALIASES = 'SupportSettingsSubscriberAliases'
export const SUPPORT_SETTINGS_SERVICES_HANDLE = 'SupportSettingsServicesHandle'
export const SUPPORT_SETTINGS_HANDLE_SERVICES_PACKAGES = 'SupportSettingsHandleServicesPackages'
export const SUPPORT_SETTINGS_ASIDE_MENU = 'ASideMenuSettings'
export const SUPPORT_SETTINGS_CALLS = 'SupportSettingsCalls'
export const SUPPORT_SETTINGS_INCOMING_CALL_HANDLING = 'SupportSettingsIncomingCallHandling'
export const SUPPORT_SETTINGS_BLACK_WHITE_LIST = 'SupportSettingsBlackWhiteList'
export const SUPPORT_SETTINGS_FOLLOW_ME = 'SupportSettingsFollowMe'
export const SUPPORT_SETTINGS_SPEED_DIAL = 'SupportSettingsSpeedDial'
export const SUPPORT_SETTINGS_IVR = 'SupportSettingsIvr'
export const SUPPORT_SETTINGS_VOICE_MAIL_FORWARDING = 'SupportSettingsVoiceMailForwarding'
export const SUPPORT_SETTINGS_SUBSCRIBER_PICKUP = 'SupportSettingsSubscriberPickUp'
export const SUPPORT_SETTINGS_TERMINALS = 'SupportSettingsTerminals'
export const SUPPORT_SETTINGS_TERMINALS_LIST = 'SupportSettingsTerminalsList'
export const SUPPORT_SETTINGS_FUNCTIONAL_KEYS_SETUP = 'SupportSettingsFunctionalKeysSetup'
export const SUPPORT_AUTOMATIC_TERMINALS_SETUP = 'SupportAutomaticTerminalsSetup'
export const SUPPORT_ACCOUNT = 'SupportAccount'
export const SUPPORT_CONFIDENTIALITY = 'SupportConfidentiality'
export const SUPPORT_PIN_PASSWORD_INPUT_SUPPORT = 'SupportPinPasswordInputSupport'
export const SUPPORT_CLIR_SUPPORT = 'SupportClirSupport'
export const SUPPORT_SETTINGS_NOTIFICATIONS = 'SupportSettingsNotifications'
export const SUPPORT_SETTINGS_NOTIFICATIONS_SETTINGS = 'SupportSettingsNotificationSettings'
export const SUPPORT_SETTINGS_DESKTOP_APLLICATION_SETTINGS = 'DesktopApplicationSettings'
export const SUPPORT_ALARM_SCHEDULE = 'SupportAlarmSchedule'
export const SUPPORT_ALARM_SCHEDULE_MAIN = 'SupportAlarmScheduleMain'
export const SUPPORT_ALARM_SCHEDULE_CREATE = 'SupportAlarmScheduleCreate'
export const SUPPORT_SETTINGS_ABOUT = 'SupportAbout'
export const SUPPORT_SETTINGS_INTERFACE = 'SupportSettingsInterface'
export const SUPPORT_SETTINGS_THEME = 'SupportSettingsTheme'
export const PROFILE = 'Profile'
export const PROFILE_VOICE_MAIL = 'ProfileVoiceMail'
export const AUDIO_FILES_SETTINGS = 'AudioFilesSettings'
export const SUPPORT_AUDIO_FILES_SETTINGS = 'SupportAudioFilesSettings'
export const SUPPORT_AUDIO_FILES_CATEGORIES = 'audiofiles-categories-support'
export const SUPPORT_AUDIO_FILES_CREATE = 'audiofiles-create-support'
export const SUPPORT_SETTINGS_EQUIPMENT_LIST = 'SupportSettingsEquipmentList'
export const SUPPORT_SETTINGS_SESSIONS_LIST = 'SupportSettingsSessionsList'
export const CONTACT_GROUPS_SETTINGS = 'ContactGroupsSettings'

/**
 * New items for 2.4.0
 */
export const MAIN_MENU = 'MainMenu'

export const CHAT_QUERY_SCROLL_TO = 'scrollTo'
export const CHAT_QUERY_SCROLL_TO_BOTTOM = 'bottom'
